import Networking from "../../utils/api/apiaccess";
import labels from "../../utils/constants/labels";
import Apivalues from '../url/apiurl'
function PlaceBasketOrders(data)
{
    let BaseUrl = Apivalues.BasketTrading
   
    return Networking.PostApi(BaseUrl,data).then(result => { return result })
    .catch(function (error) {
      return { "status": "F", "message": labels.messages.apierror }
    });
}
export default PlaceBasketOrders